/**
 * @generated SignedSource<<d9cbf308647e849eaec1c6821c2ba840>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutShippingAddressList_buyer$data = {
  readonly addressBook: {
    readonly addressList: ReadonlyArray<{
      readonly serviceId: string | null;
      readonly validation: {
        readonly buyerShipping: {
          readonly valid: boolean | null;
        } | null;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"CheckoutAddressView_address">;
    } | null> | null;
    readonly personalAddressId: number | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutShippingForm_buyer">;
  readonly " $fragmentType": "CheckoutShippingAddressList_buyer";
};
export type CheckoutShippingAddressList_buyer$key = {
  readonly " $data"?: CheckoutShippingAddressList_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutShippingAddressList_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutShippingAddressList_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutShippingForm_buyer"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AddressBook",
      "kind": "LinkedField",
      "name": "addressBook",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "personalAddressId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "addressList",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CheckoutAddressView_address"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AddressValidation",
              "kind": "LinkedField",
              "name": "validation",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ValidationResult",
                  "kind": "LinkedField",
                  "name": "buyerShipping",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "valid",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "2689339df500a1f3758703591afb934f";

export default node;
